<template>
    <div v-if="links.length" class="request-links mt-3 pt-3 border-top">
        <h6 class="mb-2">
            <i class="fas fa-link"></i>
            Связанные заявки
        </h6>
        <div class="request-links-list">
            <button
                v-for="link in links"
                :key="link.id"
                type="button"
                class="request-link-row"
                @click="openRequest(link)"
            >
                <span class="request-link-label">{{ link.label }}</span>
                <span class="request-link-main">
                    #{{ link.request.request_number || link.request.id }}
                    <span v-if="link.request.type_name" class="text-muted">
                        {{ link.request.type_name }}
                    </span>
                    <b-badge
                        v-if="link.request.status"
                        :variant="link.request.status_variant || 'secondary'"
                        class="ml-1"
                    >
                        {{ link.request.status_label || link.request.status }}
                    </b-badge>
                </span>
                <span
                    v-if="link.request.title"
                    class="request-link-title text-muted"
                >
                    {{ link.request.title }}
                </span>
                <span
                    v-if="link.request.building_object_name || link.request.building_contract_name"
                    class="request-link-object text-muted"
                >
                    <span v-if="link.request.building_object_name">{{ link.request.building_object_name }}</span>
                    <span v-if="link.request.building_contract_name">
                        Договор: {{ link.request.building_contract_name }}
                    </span>
                </span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RequestLinks',
    props: {
        links: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        openRequest(link) {
            const requestId = link && link.request ? link.request.id : null;
            if (!requestId) {
                return;
            }
            this.$router.push({ name: 'request-card', params: { id: requestId } }).catch(() => {});
        }
    }
};
</script>

<style scoped>
.request-links-list {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
}

.request-link-row {
    display: grid;
    grid-template-columns: minmax(9rem, 0.35fr) minmax(12rem, 0.65fr);
    gap: 0.15rem 0.75rem;
    width: 100%;
    padding: 0.5rem 0;
    border: 0;
    border-bottom: 1px solid #f0f1f2;
    background: transparent;
    color: inherit;
    text-align: left;
    cursor: pointer;
}

.request-link-row:hover,
.request-link-row:focus {
    color: #0056b3;
}

.request-link-label {
    font-weight: 600;
}

.request-link-main,
.request-link-title,
.request-link-object {
    min-width: 0;
}

.request-link-title,
.request-link-object {
    grid-column: 2;
    font-size: 0.875rem;
}

.request-link-object {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
}

@media (max-width: 767.98px) {
    .request-link-row {
        grid-template-columns: 1fr;
    }

    .request-link-title,
    .request-link-object {
        grid-column: 1;
    }
}
</style>
